module.exports = __webpack_public_path__ + "img/wpp-logo.6be5c053.svg";